import { Trans, useLingui } from '@lingui/react/macro';

import { FilterCheckboxItem } from '@/design_system/Filters/FiltersMenu/FilterCheckboxItem';
import { FiltersMenu, FiltersSubMenu } from '@/design_system/Filters/FiltersMenu/FiltersMenu';
import { FilterTag } from '@/design_system/Filters/FiltersMenu/FilterTag';
import IconTask from '@/icons/Task.svg';
import { TRAITS } from '@/models/entity';

import { useFilters } from '../FiltersState';

export const FiltersTrait = ({ tag }: { tag?: boolean }) => {
  const { t, i18n } = useLingui();

  const {
    traits: { traits, setTraits },
  } = useFilters();

  const options = TRAITS.map(({ id, label }) => (
    <FilterCheckboxItem
      key={id}
      checked={traits.includes(id)}
      onChange={(checked) => {
        if (checked) {
          setTraits([...traits, id]);
        } else {
          setTraits(traits.filter((trait) => trait !== id));
        }
      }}
    >
      {i18n._(label)}
    </FilterCheckboxItem>
  ));

  if (tag) {
    if (traits.length === 0) {
      return null;
    }

    const numberOfTraits = traits.length;

    return (
      <FiltersMenu
        button={
          <FilterTag
            label={t({
              id: 'settings.organization.entities.entities.filters.trait.label',
              message: 'Trait',
            })}
            value={
              traits.length === 1 ? (
                i18n._(TRAITS.find((trait) => trait.id === traits[0])!.label)
              ) : (
                <Trans id="settings.organization.entities.entities.filters.trait.multiple">
                  {numberOfTraits} traits
                </Trans>
              )
            }
            tooltip={
              traits.length > 1
                ? traits
                    .map((trait) => i18n._(TRAITS.find((st) => st.id === trait)!.label))
                    .join(', ')
                : undefined
            }
            onClear={() => setTraits([])}
          />
        }
      >
        {options}
      </FiltersMenu>
    );
  }

  return (
    <FiltersSubMenu
      icon={<IconTask />}
      label={t({
        id: 'settings.organization.entities.entities.filters.trait.label',
        message: 'Trait',
      })}
    >
      {options}
    </FiltersSubMenu>
  );
};
